import { sendToMixpanel } from '../../mixpanel';

const trackEnquiryFormViewed = (): void => {
  sendToMixpanel('Display Contact Agent Form', {
    enquiryCTA: 'Agent Profile - Viewed Enquiry Form',
  });
};

export default trackEnquiryFormViewed;
